var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.336 7.54C47.635 7.54 46.977 7.547 46.318 7.564V5.326H45.584C31.322 5.326 26.541 8.737 24.999 10.578C23.457 8.737 18.676 5.326 4.414 5.326H3.68V7.563C3.022 7.545 2.364 7.54 1.664 7.54H0V39.89H1.664C19.259 39.89 22.85 43.925 23.362 44.674H26.664C27.221 43.89 30.882 39.89 48.337 39.89H50V7.54H48.336ZM23.899 38.431C21.442 36.619 16.288 34.517 5.516 34.377V7.175C20.603 7.369 23.517 11.502 23.899 12.175V38.431ZM44.484 34.377C33.712 34.517 28.558 36.617 26.101 38.431V12.184C26.517 11.447 29.513 7.37 44.484 7.177V34.377Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBook);
export default __webpack_public_path__ + "static/media/open-book.82f55c9c090bcad1868c1bbdaa8868b3.svg";
export { ForwardRef as ReactComponent };